import React from "react";
import { IdView, Typography } from "../../../../../../components";
import { OrderData } from "./utils";

interface OrderIdCellProps {
  order: OrderData;
}

const OrderIdCell: React.FC<OrderIdCellProps> = ({ order }) => {
  return (
    <div className="flex items-center gap-[4px]">
      <IdView textToCopy={order.id}>
        {order.internalId}
      </IdView>
    </div>
  );
};

export default OrderIdCell;
